var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  RestError: () => import_restError.RestError,
  agentPolicy: () => import_agentPolicy.agentPolicy,
  agentPolicyName: () => import_agentPolicy.agentPolicyName,
  auxiliaryAuthenticationHeaderPolicy: () => import_auxiliaryAuthenticationHeaderPolicy.auxiliaryAuthenticationHeaderPolicy,
  auxiliaryAuthenticationHeaderPolicyName: () => import_auxiliaryAuthenticationHeaderPolicy.auxiliaryAuthenticationHeaderPolicyName,
  bearerTokenAuthenticationPolicy: () => import_bearerTokenAuthenticationPolicy.bearerTokenAuthenticationPolicy,
  bearerTokenAuthenticationPolicyName: () => import_bearerTokenAuthenticationPolicy.bearerTokenAuthenticationPolicyName,
  createDefaultHttpClient: () => import_defaultHttpClient.createDefaultHttpClient,
  createEmptyPipeline: () => import_pipeline.createEmptyPipeline,
  createFile: () => import_file.createFile,
  createFileFromStream: () => import_file.createFileFromStream,
  createHttpHeaders: () => import_httpHeaders.createHttpHeaders,
  createPipelineFromOptions: () => import_createPipelineFromOptions.createPipelineFromOptions,
  createPipelineRequest: () => import_pipelineRequest.createPipelineRequest,
  decompressResponsePolicy: () => import_decompressResponsePolicy.decompressResponsePolicy,
  decompressResponsePolicyName: () => import_decompressResponsePolicy.decompressResponsePolicyName,
  defaultRetryPolicy: () => import_defaultRetryPolicy.defaultRetryPolicy,
  exponentialRetryPolicy: () => import_exponentialRetryPolicy.exponentialRetryPolicy,
  exponentialRetryPolicyName: () => import_exponentialRetryPolicy.exponentialRetryPolicyName,
  formDataPolicy: () => import_formDataPolicy.formDataPolicy,
  formDataPolicyName: () => import_formDataPolicy.formDataPolicyName,
  getDefaultProxySettings: () => import_proxyPolicy.getDefaultProxySettings,
  isRestError: () => import_restError.isRestError,
  logPolicy: () => import_logPolicy.logPolicy,
  logPolicyName: () => import_logPolicy.logPolicyName,
  multipartPolicy: () => import_multipartPolicy.multipartPolicy,
  multipartPolicyName: () => import_multipartPolicy.multipartPolicyName,
  ndJsonPolicy: () => import_ndJsonPolicy.ndJsonPolicy,
  ndJsonPolicyName: () => import_ndJsonPolicy.ndJsonPolicyName,
  proxyPolicy: () => import_proxyPolicy.proxyPolicy,
  proxyPolicyName: () => import_proxyPolicy.proxyPolicyName,
  redirectPolicy: () => import_redirectPolicy.redirectPolicy,
  redirectPolicyName: () => import_redirectPolicy.redirectPolicyName,
  retryPolicy: () => import_retryPolicy.retryPolicy,
  setClientRequestIdPolicy: () => import_setClientRequestIdPolicy.setClientRequestIdPolicy,
  setClientRequestIdPolicyName: () => import_setClientRequestIdPolicy.setClientRequestIdPolicyName,
  systemErrorRetryPolicy: () => import_systemErrorRetryPolicy.systemErrorRetryPolicy,
  systemErrorRetryPolicyName: () => import_systemErrorRetryPolicy.systemErrorRetryPolicyName,
  throttlingRetryPolicy: () => import_throttlingRetryPolicy.throttlingRetryPolicy,
  throttlingRetryPolicyName: () => import_throttlingRetryPolicy.throttlingRetryPolicyName,
  tlsPolicy: () => import_tlsPolicy.tlsPolicy,
  tlsPolicyName: () => import_tlsPolicy.tlsPolicyName,
  tracingPolicy: () => import_tracingPolicy.tracingPolicy,
  tracingPolicyName: () => import_tracingPolicy.tracingPolicyName,
  userAgentPolicy: () => import_userAgentPolicy.userAgentPolicy,
  userAgentPolicyName: () => import_userAgentPolicy.userAgentPolicyName
});
module.exports = __toCommonJS(src_exports);
var import_pipeline = require("./pipeline.js");
var import_createPipelineFromOptions = require("./createPipelineFromOptions.js");
var import_defaultHttpClient = require("./defaultHttpClient.js");
var import_httpHeaders = require("./httpHeaders.js");
var import_pipelineRequest = require("./pipelineRequest.js");
var import_restError = require("./restError.js");
var import_decompressResponsePolicy = require("./policies/decompressResponsePolicy.js");
var import_exponentialRetryPolicy = require("./policies/exponentialRetryPolicy.js");
var import_setClientRequestIdPolicy = require("./policies/setClientRequestIdPolicy.js");
var import_logPolicy = require("./policies/logPolicy.js");
var import_multipartPolicy = require("./policies/multipartPolicy.js");
var import_proxyPolicy = require("./policies/proxyPolicy.js");
var import_redirectPolicy = require("./policies/redirectPolicy.js");
var import_systemErrorRetryPolicy = require("./policies/systemErrorRetryPolicy.js");
var import_throttlingRetryPolicy = require("./policies/throttlingRetryPolicy.js");
var import_retryPolicy = require("./policies/retryPolicy.js");
var import_tracingPolicy = require("./policies/tracingPolicy.js");
var import_defaultRetryPolicy = require("./policies/defaultRetryPolicy.js");
var import_userAgentPolicy = require("./policies/userAgentPolicy.js");
var import_tlsPolicy = require("./policies/tlsPolicy.js");
var import_formDataPolicy = require("./policies/formDataPolicy.js");
var import_bearerTokenAuthenticationPolicy = require("./policies/bearerTokenAuthenticationPolicy.js");
var import_ndJsonPolicy = require("./policies/ndJsonPolicy.js");
var import_auxiliaryAuthenticationHeaderPolicy = require("./policies/auxiliaryAuthenticationHeaderPolicy.js");
var import_agentPolicy = require("./policies/agentPolicy.js");
var import_file = require("./util/file.js");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RestError,
  agentPolicy,
  agentPolicyName,
  auxiliaryAuthenticationHeaderPolicy,
  auxiliaryAuthenticationHeaderPolicyName,
  bearerTokenAuthenticationPolicy,
  bearerTokenAuthenticationPolicyName,
  createDefaultHttpClient,
  createEmptyPipeline,
  createFile,
  createFileFromStream,
  createHttpHeaders,
  createPipelineFromOptions,
  createPipelineRequest,
  decompressResponsePolicy,
  decompressResponsePolicyName,
  defaultRetryPolicy,
  exponentialRetryPolicy,
  exponentialRetryPolicyName,
  formDataPolicy,
  formDataPolicyName,
  getDefaultProxySettings,
  isRestError,
  logPolicy,
  logPolicyName,
  multipartPolicy,
  multipartPolicyName,
  ndJsonPolicy,
  ndJsonPolicyName,
  proxyPolicy,
  proxyPolicyName,
  redirectPolicy,
  redirectPolicyName,
  retryPolicy,
  setClientRequestIdPolicy,
  setClientRequestIdPolicyName,
  systemErrorRetryPolicy,
  systemErrorRetryPolicyName,
  throttlingRetryPolicy,
  throttlingRetryPolicyName,
  tlsPolicy,
  tlsPolicyName,
  tracingPolicy,
  tracingPolicyName,
  userAgentPolicy,
  userAgentPolicyName
});
